import { gql } from '@apollo/client';
import { LeaveSubtypeFragment } from './leave-subtype.fragment';
export const FetchLeaveSubtypesQuery = gql `
    query FetchLeaveSubtypesForSettings($institutionSetId: InstitutionSetId!) {
        staffhours {
            leaves {
                subtypes {
                    listV2(institutionSetId: $institutionSetId) {
                        ...LeaveSubtypeFragment
                    }
                }
            }
        }
    }

    ${LeaveSubtypeFragment}
`;
